import { useDispatch, useSelector } from 'react-redux';

import {
  getProducts,
  setProductsAction,
  clearProductsAction,
  setProductsHighlightedAction,
  clearProductsHighlightedAction,
  setProductsContinuationAction,
  clearProductsContinuationAction,
  setProductDetailsAction,
  clearProductDetailsAction,
  setProductsMyAction,
  clearProductsMyAction,
  setProductsCompletedAction,
  clearProductsCompletedAction,
  setProductsTeachersAction,
  clearProductsTeachersAction,
  setProductEvolutionDetailsAction,
  clearProductEvolutionDetailsAction,
  setAvailableClassesAction,
  clearAvailableClassesAction,
  setProgramsAction,
  clearProgramsAction,
  setProgramsMyAction,
  clearProgramsMyAction,
} from 'features/products/redux/slice';

import {
  // UseProductsState,
  ProductsApiResponse,
  ProductsHighlightedApiResponse,
  ProductsContinuationApiResponse,
  ProductDetailsApiResponse,
  ProductsMyApiResponse,
  ProductsCompletedApiResponse,
  ProductsTeachersApiResponse,
  ProductEvolutionDetailsApiResponse,
  AvailableClassesApiResponse,
  ProgramsApiResponse,
} from './types';

const useMenu = () => {
  const all = useSelector(getProducts);
  const dispatch = useDispatch();

  const setProducts = (receivedProducts: ProductsApiResponse) => {
    dispatch(setProductsAction(receivedProducts));
  };

  const clearProducts = () => {
    dispatch(clearProductsAction());
  };

  const setProductsHighlighted = (receivedProductsHighlighted: ProductsHighlightedApiResponse) => {
    dispatch(setProductsHighlightedAction(receivedProductsHighlighted));
  };

  const clearProductsHighlighted = () => {
    dispatch(clearProductsHighlightedAction());
  };

  const setProductsMy = (receivedProductsMy: ProductsMyApiResponse) => {
    dispatch(setProductsMyAction(receivedProductsMy));
  };

  const clearProductsMy = () => {
    dispatch(clearProductsMyAction());
  };

  const setProductsTeachers = (receivedProductsTeachers: ProductsTeachersApiResponse) => {
    dispatch(setProductsTeachersAction(receivedProductsTeachers));
  };

  const clearProductsTeachers = () => {
    dispatch(clearProductsTeachersAction());
  };

  const setProductsCompleted = (receivedProductsCompleted: ProductsCompletedApiResponse) => {
    dispatch(setProductsCompletedAction(receivedProductsCompleted));
  };

  const clearProductsCompleted = () => {
    dispatch(clearProductsCompletedAction());
  };

  const setProductsContinuation = (receivedProductsContinuation: ProductsContinuationApiResponse) => {
    dispatch(setProductsContinuationAction(receivedProductsContinuation));
  };

  const clearProductsContinuation = () => {
    dispatch(clearProductsContinuationAction());
  };

  const setProductDetails = (receivedProductDetails: ProductDetailsApiResponse) => {
    dispatch(setProductDetailsAction(receivedProductDetails));
  };

  const clearProductDetails = () => {
    dispatch(clearProductDetailsAction());
  };

  const setProductEvolutionDetails = (receivedProductEvolutionDetails: ProductEvolutionDetailsApiResponse) => {
    dispatch(setProductEvolutionDetailsAction(receivedProductEvolutionDetails));
  };

  const clearProductEvolutionDetails = () => {
    dispatch(clearProductEvolutionDetailsAction());
  };

  const setAvailableClasses = (receivedAvailableClasses: AvailableClassesApiResponse) => {
    dispatch(setAvailableClassesAction(receivedAvailableClasses));
  };

  const clearAvailableClasses = () => {
    dispatch(clearAvailableClassesAction());
  };

  const setPrograms = (receivedPrograms: ProgramsApiResponse) => {
    dispatch(setProgramsAction(receivedPrograms));
  };

  const clearPrograms = () => {
    dispatch(clearProgramsAction());
  };

  const setProgramsMy = (receivedPrograms: ProgramsApiResponse) => {
    dispatch(setProgramsMyAction(receivedPrograms));
  };

  const clearProgramsMy = () => {
    dispatch(clearProgramsMyAction());
  };

  return {
    ...all,
    setProducts,
    clearProducts,

    setProductsHighlighted,
    clearProductsHighlighted,

    setProductsMy,
    clearProductsMy,
    setProductsTeachers,
    clearProductsTeachers,

    setProductsCompleted,
    clearProductsCompleted,

    setProductsContinuation,
    clearProductsContinuation,

    setProductDetails,
    clearProductDetails,

    setProductEvolutionDetails,
    clearProductEvolutionDetails,

    setAvailableClasses,
    clearAvailableClasses,

    setPrograms,
    clearPrograms,

    setProgramsMy,
    clearProgramsMy,
  };
};

export default useMenu;
